import styled from 'styled-components';
import {Link} from 'react-router-dom';

export const LogoImg = styled.img`
&.LogoResults{
  width: 59px;
  height: 53px;
}
&.LogoSignIn{
  width: 77px;
  height: 70px;
}
&.Home{
  width: 103px;
  height: 93px;
}
`;

export const LogoLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  &:hover{
    text-decoration: none;
  }
`

export const LogoText = styled.span`
  padding-left: 5px;
  font-family: Manrope,sans-serif;
  font-style: normal;
  font-weight: 800;
  text-align: center;
  color: #1C62EF;
  font-size: 28px;
  display: none;
  
  @media screen and (min-width: 768px) {
    padding-left: 10px;
    font-weight: 900;
    font-size: 42px;
  }
  
  @media screen and (min-width: 576px) {
    display: inline-block;
  }
`